// Mirrors song_proposals/youtube.py's YOUTUBE_ID_PATTERN - keep both
// in sync if this ever changes.
const YOUTUBE_ID_PATTERN = /[?&]v=([\w-]+)|youtu\.be\/([\w-]+)/;

export const extractYoutubeId = (link) => {
  const match = YOUTUBE_ID_PATTERN.exec(link || "");
  if (!match) return null;
  return match[1] || match[2];
};

// Strips the "(Official Video)"/"[Lyric Video]"/"| Official Audio"
// style noise real YouTube titles carry, so an autofilled title reads
// closer to what someone would actually type by hand. Deliberately
// conservative - this only ever removes an obvious video-format
// annotation, never attempts to split "Artist - Song" (too ambiguous
// to guess reliably either way round), so the result is a starting
// point to review/edit, not a guaranteed-clean title.
export const cleanYoutubeTitle = (rawTitle) => {
  if (!rawTitle) return "";
  return rawTitle
    .replace(/[([][^)\]]*\b(official|lyrics?|audio|video|hd|hq|live)\b[^)\]]*[)\]]/gi, "")
    .replace(/[|\-–]\s*(official\s+)?(lyric\s+|music\s+)?(video|audio)\s*$/i, "")
    .replace(/\s{2,}/g, " ")
    .trim();
};
